import axios from '@/axios';
import { AxiosInstance } from 'axios';
import { normalizeScannerCredentialField } from '../utils/normalizeScannerCredentialField';
import type {
  TNormalizedScannerCredentialField,
  TScannerCredentialFieldsQueryPayload,
  TScannerCredentialFieldsUpdatePayload,
} from '../models/types';

const axiosInstance = axios as AxiosInstance;

function normalizeScannerCredentialFields(
  scannerCredentialFields: unknown
): TNormalizedScannerCredentialField[] {
  if (!Array.isArray(scannerCredentialFields)) {
    return [];
  }

  return scannerCredentialFields
    .map(normalizeScannerCredentialField)
    .filter((field) => !!field.fieldKey);
}

export async function fetchScannerCredentialFields(
  payload: TScannerCredentialFieldsQueryPayload
): Promise<TNormalizedScannerCredentialField[]> {
  if (payload.mode === 'single-scan') {
    const response = await axiosInstance.get('/private/ui/single-scans/scanner-credential-fields');
    return normalizeScannerCredentialFields(response.data?.scannerCredField);
  }

  const response = await axiosInstance.get(
    `/private/ui/integrations/${payload.integrationId}/scanner-credential-fields`
  );

  return normalizeScannerCredentialFields(response.data?.scannerCredField);
}

export async function updateScannerCredentialFields(
  payload: TScannerCredentialFieldsUpdatePayload
): Promise<TNormalizedScannerCredentialField[]> {
  if (payload.mode === 'single-scan') {
    const response = await axiosInstance.put('/private/ui/single-scans/scanner-credential-fields', {
      scannerCredField: payload.scannerCredentialFields,
    });

    return normalizeScannerCredentialFields(response.data?.scannerCredField);
  }

  const response = await axiosInstance.put(
    `/private/ui/integrations/${payload.integrationId}/scanner-credential-fields`,
    {
      scannerCredField: payload.scannerCredentialFields,
    }
  );

  return normalizeScannerCredentialFields(response.data?.scannerCredField);
}
